import { z } from 'zod'

export const USERNAME_MIN_LENGTH = 3
export const USERNAME_MAX_LENGTH = 20

export const UsernameSchema = z
	.string({ required_error: 'Gebruikersnaam is vereist' })
	.min(USERNAME_MIN_LENGTH, { message: 'Gebruikersnaam is te kort' })
	.max(USERNAME_MAX_LENGTH, { message: 'Gebruikersnaam is te lang' })
	.regex(/^[a-zA-Z0-9_]+$/, {
		message:
			'Gebruikersnaam mag alleen letters, cijfers en underscores bevatten',
	})
	// users can type the username in any case, but we store it in lowercase
	.transform((value) => value.toLowerCase())

export const PasswordSchema = z
	.string({ required_error: 'Wachtwoord is vereist' })
	.min(6, { message: 'Wachtwoord is te kort' })
	.max(100, { message: 'Wachtwoord is te lang' })
export const NameSchema = z
	.string({ required_error: 'Naam is vereist' })
	.min(3, { message: 'Naam is te kort' })
	.max(40, { message: 'Naam is te lang' })
export const EmailSchema = z
	.string({ required_error: 'E-mail is vereist' })
	.email({ message: 'E-mail is ongeldig' })
	.min(3, { message: 'E-mail is te kort' })
	.max(100, { message: 'E-mail is te lang' })
	// users can type the email in any case, but we store it in lowercase
	.transform((value) => value.toLowerCase())

export const PasswordAndConfirmPasswordSchema = z
	.object({ password: PasswordSchema, confirmPassword: PasswordSchema })
	.superRefine(({ confirmPassword, password }, ctx) => {
		if (confirmPassword !== password) {
			ctx.addIssue({
				path: ['confirmPassword'],
				code: 'custom',
				message: 'De wachtwoorden moeten overeenkomen',
			})
		}
	})
